export default "__VITE_ASSET__C1bA2f$h__"